module.exports = __webpack_public_path__ + "img/qr-code.a7aaf98f.png";